import { PageContextUtils } from "./pageContextUtils.js";

export class AppFeatureUtils {
  static findIfIsInFeature = appFeature => {
    const { features } = PageContextUtils.getFeaturesData();
    return features
      ?.filter(feature => feature.value.toLowerCase() === "on")
      .some(activeFeature => activeFeature.id === appFeature);
  };
}
